import type { IAppointmentConfig } from '@bb/domain/dist/types';
import axios from 'axios';

const getListingAppointmentConfig = async (
  listingId: string,
): Promise<IAppointmentConfig> => {
  const { data: appointmentConfig } = await axios.get(
    `/listing/${listingId}/appointments/config`,
  );

  return appointmentConfig;
};

export default getListingAppointmentConfig;
